//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "integraldetail",
  data(){
      return {
        tabIndex:1,
        logList:[]
      }
  },
  methods:{
      getDetail(lx){
        this.logList=[];
        this.tabIndex=lx;
        this.$vux.loading.show();
        this.axios.post('/xcx/User/integralLog',{lx}).then(res=>{
          this.logList=res.data.data
          this.$vux.loading.hide();
        })
      }
  },
  created() {
      this.getDetail(this.tabIndex);
  }
}



// WEBPACK FOOTER //
// ./src/components/integraldetail/integraldetail.vue